module.exports = __webpack_public_path__ + "media/packs/static/fonts/circular-std/book-da91211bb1fd4f1d09d8cfc1f87970a2.woff2";